import { type FunctionComponent } from 'react';

type ContentCardDetailsProps = { title: string; description: string };

export const ContentCardDetails: FunctionComponent<ContentCardDetailsProps> = ({ title, description }) => {
	return (
		<div className="pa4 bg-theme-white br2 flex flex-column justify-center self-stretch">
			<h2 className="ma0 pa0 f3 lh-title font-medium theme-grey-darker">{title}</h2>
			<div className="theme-accent bw1 bb mv2" style={{ width: 150 }} />
			<p className="ma0 pa0 f5 lh-copy theme-grey-dark">{description}</p>
		</div>
	);
};
